import { render, staticRenderFns } from "./designTaxes.vue?vue&type=template&id=399f4845&scoped=true&"
import script from "./designTaxes.vue?vue&type=script&lang=js&"
export * from "./designTaxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399f4845",
  null
  
)

export default component.exports